import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { DISTRIBUTOR_NAME } from '@autopass-web/domain';
import { Splash } from '@autopass-web/mochi-component';

import AppMessage from '../../components/app-message';
import NavBottom from '../../components/nav-bottom';
import { PATH } from '../../config';
import distributorGroup from '../../distributors';
import useAppStore from '../../pages/use-app';
import amplitude from '../../service/amplitude';
import Primary from '../primary';

const Layout = ({ children }) => {
  const router = useRouter();
  const appStore = useAppStore();
  const isUserRouter = router.asPath.includes('user');
  const primaryPage = appStore.distributor?.params.bottomTabs || [];

  if (isUserRouter) {
    return <>{children}</>;
  } else if (
    primaryPage.find(
      (page) =>
        // Maps page should always show the bottom nav
        router.pathname === `/${page}` || router.pathname.includes(PATH.MAPS),
    )
  ) {
    return (
      <>
        <Primary
          style={{
            overflow: router.asPath.includes('maps') ? 'hidden' : 'scroll',
          }}
        >
          {children}
        </Primary>
        <NavBottom />
      </>
    );
  } else if (primaryPage.length === 0) {
    return (
      <Primary
        style={{
          height: 'var(--viewHeight)',
          overflow: router.asPath.includes('maps') ? 'hidden' : 'scroll',
        }}
      >
        {children}
      </Primary>
    );
  } else {
    return children;
  }
};

const Wrapper = ({ children }) => {
  const router = useRouter();
  const appStore = useAppStore();
  const distributorType = process.env.NEXT_PUBLIC_DISTRIBUTOR; // NEED TO FIX

  const { setDistributor } = appStore;
  const [error, setError] = useState();

  // https://github.com/pmndrs/zustand#using-subscribe-with-selector
  // 監聽 distributorMethods 有值後開始執行

  let unsubscribe = useAppStore.subscribe(
    (state) => state.distributor?.methods,
    (methods) => {
      const animationDelay = new Promise((resolve) => {
        setTimeout(() => resolve(), 1000);
      });

      Promise.all([methods.splash(), animationDelay])
        .then(async (result) => {
          if (result.error) {
            // FIXME 確認回傳的內容
            console.log(result.error);
            setError(result.error);
          } else {
            appStore.initializeApp();

            if (Object.values(PATH).every((p) => !result[0].path.includes(p))) {
              // 錯誤的路徑
              throw new Error('error path');
            }

            if (result[0].path.indexOf('user') !== -1) {
              const resultPath =
                result[0].paymentBindingFail !== undefined
                  ? `${result[0].path}/?paymentBindingFail=${result[0].paymentBindingFail}`
                  : result[0].path;

              router.replace(resultPath);
            } else {
              await router.replace(PATH.MAIN);
              router.push(result[0].path);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          router.replace(PATH.USER_WELCOME);
        });
    },
  );

  useEffect(() => {
    const currentDistributorConfig = distributorGroup[distributorType];
    setDistributor({
      type: distributorType,
      name: DISTRIBUTOR_NAME[distributorType],
      methods: currentDistributorConfig.methods,
      params: currentDistributorConfig.params,
    });

    amplitude.splash();

    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distributorType]);

  if (error) {
    return (
      <AppMessage
        type="failure"
        show={true}
        message="發生錯誤"
        autoDismiss={false}
      />
    );
  }

  return (
    <>
      <Splash init={appStore.initialize} />
      {appStore.initialize && <Layout>{children}</Layout>}
    </>
  );
};

export default Wrapper;
